import React, {useState, useEffect, useRef} from 'react';
import {PageHeader, Avatar, Space, Spin, Tabs, Button, Drawer} from 'antd';
import styles from '../index.module.less';
import {sendResult} from '@/api/customer';
import MomentModal from '@/page/customer/MomentPage/MomentModal';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {getColumns} from '@/page/customer/MomentPage/momentColumns';
import {PageGrid} from '@/component';
import classNames from 'classnames';
import {EyeOutlined, UserOutlined} from '@/icons';

const {TabPane} = Tabs;
export default function MomentPage() {
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    const modalRef = useRef();
    const [customers, setCustomers] = useState([]);
    const [hoverLoading, setHoverLoading] = useState(false);
    const [momentInfo, setMomentInfo] = useState({});
    const [personalParam, setPersonalParam] = useState({createType: 1, userId});
    const [cropParam, setCropParam] = useState({createType: 0, userId});
    const [tabKey, setTabKey] = useState(0);
    const [visible, setVisible] = useState(false);
    const [url, setUrl] = useState(null);
    let columns = getColumns([
        'avatar',
        'visibleType',
        'latitudeName',
        'content',
        'momentCreateTime',
    ]);
    columns.push({
        title: '操作',
        dataIndex: 'action',
        render: (text, record) => (
            <Space>
                <Button
                    type="text"
                    icon={<UserOutlined />}
                    style={{color: '#152D85'}}
                    onClick={() => openDrawer(record)}
                >
                    客户可见范围
                </Button>
                <Button
                    type="text"
                    icon={<EyeOutlined />}
                    style={{color: '#152D85'}}
                    onClick={() => showDetail(record)}
                >
                    查看详情
                </Button>
            </Space>
        ),
    });
    useEffect(() => {
        setUrl('/customer/moment/list');
    }, []);

    function changeTab(key) {
        let createType = parseInt(key, 10);
        setTabKey(createType);
    }

    function changeCustomerTab(key) {
        let {momentId, creator} = momentInfo;
        showSendResult(momentId, creator, key === '1' ? 0 : 1);
    }

    function showSendResult(momentId, creator, type = 0) {
        setHoverLoading(true);
        setCustomers([]);
        sendResult({momentId, userId: creator, type}).then(res => {
            setCustomers(res.data.sysCustomers);
            setHoverLoading(false);
        });
    }

    function renderTabs() {
        return (
            <div className={classNames(styles.tableContainer, styles.tabContainer)}>
                <Tabs onChange={changeTab} className={styles.container} type="card">
                    <TabPane tab="企业" key="0">
                        {url && (
                            <PageGrid
                                url={url}
                                columns={columns}
                                initParams={cropParam}
                                rowKey={'uniIndex'}
                            />
                        )}
                    </TabPane>
                    <TabPane tab="个人" key="1">
                        {url && (
                            <PageGrid
                                url={url}
                                columns={columns}
                                initParams={personalParam}
                                rowKey={'uniIndex'}
                            />
                        )}
                    </TabPane>
                </Tabs>
            </div>
        );
    }

    function renderContent() {
        return (
            <div className={classNames(styles.hoverContent, styles.normalTabContainer)}>
                <Tabs tabPosition={'left'} onChange={changeCustomerTab}>
                    <TabPane tab="可见客户" key="1">
                        {customers.length > 0 &&
                            customers.map((item, key) => (
                                <p key={key}>
                                    <Avatar src={item.avatar} />
                                    <span style={{margin: '0,2px'}}> {item.name}</span>
                                </p>
                            ))}
                    </TabPane>
                    <TabPane tab="接收客户" key="2">
                        {customers.length > 0 &&
                            customers.map((item, key) => (
                                <p key={key}>
                                    <Avatar src={item.avatar} />
                                    <span style={{margin: '0,2px'}}> {item.name}</span>
                                </p>
                            ))}
                    </TabPane>
                </Tabs>
            </div>
        );
    }

    function openDrawer(record) {
        let {momentId, creator} = record;
        showSendResult(momentId, creator);
        setMomentInfo(record);
        setVisible(true);
    }

    function showDetail(record) {
        setMomentInfo(record);
        modalRef.current.open();
    }

    return (
        <div style={{overflowY: 'auto'}}>
            <PageHeader title={'朋友圈'} />
            {renderTabs()}
            <MomentModal ref={modalRef} momentInfo={momentInfo} />
            <Drawer
                title="客户可见范围"
                placement="right"
                onClose={() => setVisible(false)}
                visible={visible}
                width="400"
                destroyOnClose={true}
            >
                <Spin spinning={hoverLoading}>{renderContent()}</Spin>
            </Drawer>
        </div>
    );
}
